import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { colors } from '../../brand-colors';

function FinancialEngineer() {
  const navigate = useNavigate();

  const cards = [
    {
      title: 'Exit Strategy',
      icon: '\uD83D\uDE80',
      description: 'Plan and track your business exit timeline — valuation drivers, readiness score, and your path to a premium sale.',
      path: '/command-center/financial-engineer/exit-strategy',
      buttonText: 'View Exit Strategy',
      color: colors.goldMid
    },
    {
      title: 'Life Goals',
      icon: '\uD83C\uDFAF',
      description: 'Align your business with personal objectives — define what success looks like beyond revenue.',
      path: '/command-center/financial-engineer/life-goals',
      buttonText: 'View Life Goals',
      color: colors.navy
    },
    {
      title: 'Exit Reports',
      icon: '\uD83D\uDCCA',
      description: 'Buyer-ready reports that showcase your business value — tailored to each potential buyer\'s portfolio for maximum acquisition price.',
      path: '/command-center/financial-engineer/exit-reports',
      buttonText: 'View Exit Reports',
      color: '#27ae60',
      comingSoon: true
    }
  ];

  return (
    <Container className="py-4">
      <div className="mb-4">
        <h1 style={{
          fontFamily: "'Trajan Pro', 'Trajan Pro 3', 'Times New Roman', serif",
          letterSpacing: '0.15em',
        }}>Financial Engineer</h1>
        <p className="text-muted">
          Plan your exit, know your number, prove the value — everything you need to sell at a premium.
        </p>
      </div>

      <Row>
        {cards.map((card) => (
          <Col key={card.title} md={6} className="mb-4">
            <Card
              className="h-100 shadow-sm"
              style={{
                border: `1px solid ${colors.greyLight}`,
                cursor: card.comingSoon ? 'default' : 'pointer',
                transition: 'all 0.2s ease',
              }}
              onClick={() => !card.comingSoon && navigate(card.path)}
              onMouseEnter={(e) => {
                if (!card.comingSoon) {
                  e.currentTarget.style.borderColor = colors.goldMid;
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = colors.greyLight;
                e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <Card.Header style={{
                backgroundColor: colors.greyDarkest,
                color: colors.goldLight,
                fontFamily: "'Trajan Pro', 'Trajan Pro 3', 'Times New Roman', serif",
                letterSpacing: '0.1em',
              }}>
                <strong>{card.title}</strong>
              </Card.Header>
              <Card.Body className="d-flex flex-column p-4">
                <p className="text-muted flex-grow-1">{card.description}</p>
                <Button
                  variant="outline-dark"
                  className="mt-auto"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!card.comingSoon) navigate(card.path);
                  }}
                  disabled={card.comingSoon}
                >
                  {card.comingSoon ? 'Coming Soon' : `Open ${card.title} \u2192`}
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default FinancialEngineer;
